var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',[(this.$route.name == 'our-portfolio-project-detail-edit-blank')?[_c('editProject')]:(this.$route.name == 'our-portfolio-project-detail-add' || this.$route.name == 'our-portfolio-project-add')?[_c('addProject')]:_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }